import script from "./Fazenda.vue?vue&type=script&setup=true&lang=js"
export * from "./Fazenda.vue?vue&type=script&setup=true&lang=js"

import "./Fazenda.vue?vue&type=style&index=0&id=1daabb8f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1daabb8f"]])

export default __exports__